import Lottie from "lottie-react";
import Banners3 from "./banner2.json";
import styled from "styled-components";
const Hero3 = () => {
  return (
    <div
      className="relative w-full"
      style={{
        height: "500px",
      }}
    >
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source
          src="https://cdn.pixabay.com/video/2022/11/20/139809-773444533_large.mp4"
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>

      <div className="absolute inset-0 bg-gradient-to-l from-violet-600/80 to-indigo-600/80 flex items-center justify-center">
        <Div>
          <main
            className="hero container items-center flex"
            style={{
              padding: "0.4rem 1.5rem",
            }}
          >
            <div className="hero-content flex-1">
              <h1>Drive Smarter, Deliver Faster, Manage Better.</h1>
              <p className="text-white">
                Streamline dispatch, routing, driver management, invoicing, and
                more — all in one place.
              </p>
              <div className="flex gap-3">
                <button className="bg-white text-indigo-500 px-4 py-2 rounded">
                  Start Free Trial
                </button>
                <button className="b-white border text-white px-4 py-2 rounded">
                  Watch Demo
                </button>
              </div>
            </div>
            <div className="flex-1">
              {/* <Lottie animationData={Banners3} loop={true} /> */}
              <img
                src="./images/tablet-1.png"
                style={{
                  position: "relative",

                  //   marginTop: "-170px",
                }}
              />
            </div>
          </main>
        </Div>
      </div>
    </div>
  );
};

export default Hero3;

const Div = styled("div")`
  overflow: hidden;
  margin-top: 30px;

  .hero {
    /* padding: 8rem 6rem 6rem; */
    min-height: 90vh;
    display: flex;
    align-items: center;
    position: relative;
    margin: 0 auto;
  }

  .hero-content {
    max-width: 650px;
    position: relative;
    z-index: 2;
  }

  .hero h1 {
    font-size: 3.5rem;
    line-height: 1.1;
    margin-bottom: 1.5rem;
    font-weight: 700;
    letter-spacing: -1px;
    background: linear-gradient(135deg, #fff 0%, #e7e7e7 100%);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }

  .hero p {
    font-size: 1.25rem;
    margin-bottom: 2.5rem;
    font-weight: 400;
    max-width: 580px;
  }

  .hero-graphics {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 50%;
    height: 100%;
    z-index: 1;
  }

  .gradient-orb {
    position: absolute;
    width: 800px;
    height: 800px;
    right: -200px;
    top: 50%;
    transform: translateY(-50%);
    background: radial-gradient(
      circle,
      rgba(99, 102, 241, 0.15) 0%,
      rgba(99, 102, 241, 0.1) 25%,
      rgba(99, 102, 241, 0) 70%
    );
    border-radius: 50%;
    filter: blur(40px);
  }

  .floating-cards {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .card {
    position: absolute;
    background: var(--bg-card);
    backdrop-filter: blur(10px);
    border-radius: 20px;
    border: 1px solid var(--border-color);
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  }

  .card-1 {
    width: 300px;
    height: 200px;
    top: 20%;
    right: 20%;
    --rotation: -15deg;
    transform: rotate(var(--rotation));
    animation: float 6s ease-in-out infinite;
  }

  .card-2 {
    width: 250px;
    height: 150px;
    top: 40%;
    right: 40%;
    --rotation: 10deg;
    transform: rotate(var(--rotation));
    animation: float 8s ease-in-out infinite;
  }

  .card-3 {
    width: 200px;
    height: 120px;
    top: 60%;
    right: 30%;
    --rotation: -5deg;
    transform: rotate(var(--rotation));
    animation: float 7s ease-in-out infinite;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0) rotate(var(--rotation));
    }
    50% {
      transform: translateY(-20px) rotate(var(--rotation));
    }
  }

  @media (max-width: 1200px) {
    .hero h1 {
      font-size: 4rem;
    }

    .hero-graphics {
      opacity: 0.5;
    }
  }

  @media (max-width: 992px) {
    nav {
      padding: 1.5rem 3rem;
    }

    .hero {
      padding: 8rem 3rem 6rem;
    }

    .hero h1 {
      font-size: 3.5rem;
    }
  }

  @media (max-width: 768px) {
    nav {
      padding: 1.5rem 2rem;
    }

    .nav-links {
      display: none;
    }

    .hero {
      padding: 8rem 2rem 4rem;
      text-align: center;
    }

    .hero h1 {
      font-size: 3rem;
    }

    .hero p {
      font-size: 1.1rem;
      margin-left: auto;
      margin-right: auto;
    }

    .cta-group {
      justify-content: center;
    }

    .stats-container {
      flex-direction: column;
      align-items: center;
      gap: 2rem;
    }

    .stat-item {
      align-items: center;
    }

    .hero-graphics {
      display: none;
    }
  }

  @media (max-width: 480px) {
    .hero h1 {
      font-size: 2.5rem;
    }

    .cta-group {
      flex-direction: column;
    }

    .auth-buttons {
      gap: 0.5rem;
    }

    .auth-buttons button {
      padding: 0.8rem 1rem;
    }
  }
`;
